var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('full-screen-slide',{staticClass:"main-page-full-screen-slide",attrs:{"background-image-src":_vm.image.image}},[_c('main-text-block',{class:_vm.textStyleClasses,style:(_vm.textBackgroundStyle),attrs:{"title":_vm.image.title,"text":_vm.image.description}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71cbe388","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-content/MainSlideFullScreen.vue
// module id = null
// module chunks = 